module.exports = __webpack_public_path__ + "img/CNBV.46c5facd.png";